import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { clearOAuthReturnPath, readOAuthReturnPath, workspaceHomeTarget } from "@/workspaceRouting.mjs";

export default function WorkspaceHome({ children }) {
  const { activeClient } = useApp();
  const location = useLocation();
  const [returnPath] = useState(readOAuthReturnPath);
  useEffect(() => { clearOAuthReturnPath(); }, []);
  const currentPath = `${location.pathname}${location.search}${location.hash}`;
  const target = returnPath && returnPath !== "/" && returnPath !== currentPath
    ? returnPath
    : workspaceHomeTarget(activeClient?.clientSlug, location);
  return target ? <Navigate to={target} replace state={location.state} /> : children;
}
